import { createFileRoute } from "@tanstack/react-router";
import AdminClientPanel from "@/pages/admin/AdminClientPanel";

export const Route = createFileRoute("/admin/crm/$userId/panel")({ component: AdminClientPanel });
